var path = 'entity/entity-select.tpl.html';
var html = " <div layout=row class=tb-entity-select> <tb-entity-type-select style=min-width:100px the-form=theForm ng-disabled=disabled tb-required=tbRequired use-alias-entity-types=useAliasEntityTypes ng-model=model.entityType> </tb-entity-type-select> <tb-entity-autocomplete flex ng-if=model.entityType the-form=theForm ng-disabled=disabled tb-required=tbRequired entity-type=model.entityType ng-model=model.entityId> </tb-entity-autocomplete> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity/entity-select.tpl.html
// module id = 1489
// module chunks = 1